import StickyOverlayScrollbars from "app/WebController/Component/Scroll/StickyOverlayScrollbars"
import {Options} from "overlayscrollbars"
import {OverlayScrollbarsComponentRef} from "overlayscrollbars-react"
import React, {Dispatch, forwardRef, ReactNode, SetStateAction, useState} from "react"

export interface StickyScrollProps {
  className: string
  children: ReactNode | ReactNode[]
  options?: DeepPartial<Options>,
  setHasScrollbar?: Dispatch<SetStateAction<boolean>>
  display?: 'flex'
  contain?: 'size'
}

// Wrap scroll so we can easily swap it out
const StickyScroll = forwardRef<OverlayScrollbarsComponentRef | null, StickyScrollProps>(
  ({
     className,
     children,
     ...props
   }: StickyScrollProps, ref) => {

    const [localClass] = useState(`scroll-${className}`)

    return (
      <StickyOverlayScrollbars ref={ref} className={localClass} {...props}>
        {children}
      </StickyOverlayScrollbars>
    )

  })

export default StickyScroll
